<div class="flex items-center justify-end gap-2 pr-[0.25em]">
  <app-pan-button
    color="info"
    icon="visibility"
    matTooltip="View Details"
    data-testid="incident-view-button"
    (click)="params.viewCallback(params, params.data)"
  ></app-pan-button>
</div>
